import { reactive } from 'vue'
import actions from '@/store/tutor/actions'
import state from '@/store/tutor/state'
import getters from '@/store/tutor/getters'

export const tutorModule = {
    state: reactive(state),
    actions,
    getters,
}
